import React, { useState, useRef, useEffect } from "react";

const AgeDropdown = ({ selectedAge, formData, setFormData, error }) => {
  // const [ageSelected, setAgeSelected] = useState(""); // Fix variable name (Ageselected -> ageSelected)
  const [isAgeOpen, setIsAgeOpen] = useState(false);
  const dropdownRef = useRef(null); // Ref for the dropdown container

  const ageOptions = ["Below 18", "18 - 35", "35 - Above"];

  const handleSelected = (ageOption) => {
    setIsAgeOpen(false);
    setFormData((prev) => ({
      ...prev,
      ageGroup: ageOption, // Update form data with selected age group
    }));
  };

  // Close dropdown if click happens outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsAgeOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Label */}
      <label
        htmlFor="ageGroup"
        className="block text-sm font-medium text-[#cccccc] mb-1 flex justify-between"
      >
        Age Group <span className="text-gray-400 text-xs">(Optional)</span>
      </label>

      {/* Dropdown Button */}
      <div
      id="ageGroup"
        name="ageGroup"
        className="flex justify-between items-center px-4 py-2 h-12 bg-[#F1F1F1] cursor-pointer"
        onClick={() => setIsAgeOpen(!isAgeOpen)} // Toggle dropdown visibility
      >
        <span className="text-sm text-gray-600">
          {selectedAge || "Select Age Group"}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 transform transition-transform ${
            isAgeOpen ? "rotate-180" : "rotate-0"
          }`}
          viewBox="0 0 20 20"
          fill="text-gray-600"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      {error && <span className="text-red-500 text-sm">{error}</span>}

      {/* Dropdown Options */}
      {isAgeOpen && (
        <div className="absolute w-full bg-white mt-1 shadow-lg z-10">
          {ageOptions.map((ageOption, index) => (
            <div
              key={index}
              className={`px-4 py-2 text-md cursor-pointer ${
                 formData?.ageGroup === ageOption
                  ? "bg-gray-200 text-black border-l-4 border-[#ec1c24]" // Highlight selected option
                  : "hover:bg-gray-200 text-black" // Default styling for unselected options
              }`}
              onClick={() => handleSelected(ageOption)}
            >
              {ageOption}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgeDropdown;
